module.exports = __webpack_public_path__ + "static/media/ico-open-tab.f0e95676.svg";